import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../services/api.service';
import { Title } from '@angular/platform-browser';
import {MetatagService} from '../../services/metatag.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
})
export class WelcomeComponent implements OnInit {
  public isLoggedIn = ApiService.isLoggedIn;

  constructor(private titleService: Title, private metatagService: MetatagService) { }

  ngOnInit() {
      this.titleService.setTitle('Welkom bij Dermabase');

      this.metatagService.getPageInfo('node/47').subscribe((res) => {
          const desc: string = (res.field_me.length) ? res.field_me[0].value : '';
          const keywords: string = (res.field_meta_keywords.length) ? res.field_meta_keywords[0].value : '';

          this.metatagService.setMetaTags(desc, keywords);

      }, (error) => {
          console.log('welcome error: ' + error);
      });
  }

}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/welcome/welcome.component.ts